import { useEffect, useRef } from "react";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import {
    useForm,
    useFetch,
    useToast,
    usePopup,
    useTheme,
    useStore,
    useGrid,
    useModal,
    useResource,
} from "@/comn/hooks";
import { BASE, APIS, SF_USR_BY_ROLE_SRCH, SG_USR_BY_ROLE_LIST } from "./services/OsciComnPpupService";

export const UsrLstbyRole = (props: any) => {
    const { params, onSelected } = props;

    console.log("params ", params);

    useResource({
        defaultSchema: [],
    });

    const pgeUid = "usrByOrgRoleLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const { close, postMessage, getParams } = usePopup();
    //const params = getParams(); /* * */
    const { theme } = useTheme();

    const refDefaultParam = useRef({});

    const form = {
        usrSrch: useForm({
            defaultSchema: SF_USR_BY_ROLE_SRCH,
            defaultValues: { ...pgeStore?.form, tin: params?.tin || "" },
        }),
    };

    const grid = {
        usrLst: useGrid({
            defaultSchema: SG_USR_BY_ROLE_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getUsrLst: useFetch({
            api: (page = grid.usrLst.page) => {
                return APIS.getUsrByOrgRoleLst(form.usrSrch.getValues(), page, grid.usrLst.size);
            },
            enabled: comnUtils.isEmpty(form.usrSrch.errors) && form.usrSrch.isSubmitted,
            key: [grid.usrLst.page, grid.usrLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.usrSrch.getValues(),
                    page: grid.usrLst.page,
                    size: grid.usrLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.usrSrch.handleSubmit(
                () => {
                    grid.usrLst.setPage(0);
                    fetch.getUsrLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.usrLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" });
                return;
            }

            // onSelected({ data: list });

            modal.closeModal();
        },
    };

    const render = {
        grid_UsrLst: {
            cell: {
                userName: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <a
                            href="javascrpt:void(0)"
                            onClick={(e) => {
                                e.preventDefault();
                                console.log("rowValues ", rowValues);
                                onSelected({
                                    code: rowValues.userId,
                                    label: rowValues.userName,
                                    orgCd: rowValues.orgCd,
                                });

                                modal.closeModal();
                            }}
                        >
                            {value}
                        </a>
                    );
                },
            },
        },
    };

    useEffect(() => {
        const defaultParams = {
            asnmtBsopTpCd: params.asnmtBsopTpCd,
            asnmtOfcrTpCd: params.asnmtOfcrTpCd,
            asnmtOrgCd: params.asnmtOrgCd,
            excuUserId: params.excuUserId,
            appCdNo: params.appCdNo,
        };
        refDefaultParam.current = { ...defaultParams };
        form.usrSrch.setValues({ ...defaultParams });

        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.usrLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("L_USR_LST")}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.usrSrch.schema.srchUserName}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                onClick={() => {
                                    form.usrSrch.reset({ ...refDefaultParam.current });
                                    handler.click_Btn_Srch();
                                }}
                            >
                                {t("B_RESET")}
                            </Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                onClick={() => {
                                    handler.click_Btn_Srch();
                                }}
                            >
                                {t("B_SRCH")}
                            </Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.usrLst.grid} data={fetch.getUsrLst.data?.usrList} render={render.grid_UsrLst} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
